import PropTypes from 'prop-types';
import React from 'react';
import IconDocument from '../icons/Document';

const SelfAvatar = ({ size }) => (
  <div className="flex items-center justify-center w-full h-full bg-blue-600">
    <IconDocument size={size} className="text-white fill-current max-w-three-quarters" />
  </div>
);

SelfAvatar.propTypes = {
  size: PropTypes.string,
};

SelfAvatar.defaultProps = {
  size: '6',
};

export default SelfAvatar;
